// Generated by ts-to-zod
import {z} from "zod";
import {
	mantineCssStyleRecordSchema,
	mantineResponsiveCssSizeSchema,
} from "./primitives.zod";
import {mantineSizeTokenSchema, mantineSpacingSchema} from "./spacing.zod";

export const mantineButtonPropsSchema = z.strictObject({
	fw: z.union([z.string(), z.number()]).optional(),
	mt: mantineSpacingSchema.optional(),
	ml: mantineSpacingSchema.optional(),
	px: mantineSpacingSchema.optional(),
	fz: mantineResponsiveCssSizeSchema.optional(),
	h: mantineResponsiveCssSizeSchema.optional(),
	variant: z.string().optional(),
	size: mantineSizeTokenSchema.optional(),
	fullWidth: z.boolean().optional(),
	justify: z.string().optional(),
	disabled: z.boolean().optional(),
	style: mantineCssStyleRecordSchema.optional(),
});
